import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InputText } from 'primereact/components/inputtext/InputText';
import { AppMenu } from "./AppMenu";

import { deleteToken, deleteUsuario } from './servicios/ServicioManejadorToken';
export class AppTopbar extends Component {

	constructor() {
		super();
		this.state = {};
	}

	static defaultProps = {
		menuActive: null,
		topbarUserMenuActive: false,
		model: null,
		horizontal: true,
		onRootMenuItemClick: null,
		onMenuItemClick: null,
		onSidebarClick: null,
		onMenuButtonClick: null,
		onTopbarUserMenuButtonClick: null,
		onTopbarUserMenuClick: null,
		isHorizontalMenuActive: null,
		logo:null
	}

	static propTypes = {
		menuActive: PropTypes.bool.isRequired,
		topbarUserMenuActive: PropTypes.bool.isRequired,
		model: PropTypes.array.isRequired,
		horizontal: PropTypes.bool.isRequired,
		onRootMenuItemClick: PropTypes.func.isRequired,
		onMenuItemClick: PropTypes.func.isRequired,
		onSidebarClick: PropTypes.func.isRequired,
		onMenuButtonClick: PropTypes.func.isRequired,
		onTopbarUserMenuButtonClick: PropTypes.func.isRequired,
		onTopbarUserMenuClick: PropTypes.func.isRequired,
		isHorizontalMenuActive: PropTypes.func.isRequired,
        logo : PropTypes.func.isRequired
	}

	cerrarSesion = () => {
		deleteToken();
		deleteUsuario();
		window.location = '/consultareciboquadrum';
	}

	render() {
		let isMenuButtonActive = !this.props.isHorizontalMenuActive() && this.props.menuActive;
		let topbarMenuClassName = classNames('layout-profile-menu fadeInDown ', { 'layout-profile-menu-active': this.props.topbarUserMenuActive });
		let menuButtonClassName = classNames('layout-menubutton ', { 'layout-menubutton-active': isMenuButtonActive })

		return (
			<div className="layout-topbar">
				<button className={menuButtonClassName} onClick={(e) => this.props.onMenuButtonClick(e, isMenuButtonActive)}>
					<div className="layout-menubutton-icon" />
				</button>

				<div className="layout-topbar-grid">
					<div className="layout-topbar-grid-column layout-topbar-grid-column-fixed">
						<button className="layout-logo p-link" >
							<img src={`data:image/png;base64,${this.props.logo}`} alt="sapphire-layout" />
						</button>
					</div>

					<div className="layout-topbar-grid-column">
						<AppMenu model={this.props.model} horizontal={this.props.horizontal} menuActive={this.props.menuActive} isHorizontalMenuActive={this.props.isHorizontalMenuActive}
							onMenuItemClick={this.props.onMenuItemClick} onRootMenuItemClick={this.props.onRootMenuItemClick} onSidebarClick={this.props.onSidebarClick} />
					</div>

					

					<div className="layout-topbar-grid-column layout-topbar-grid-column-fixed">
						<button className="p-link profile-menu-button" onClick={this.props.onTopbarUserMenuButtonClick}>
							<img src="assets/layout/images/icon-usersonline.svg" alt="Profile" />
						</button>
						<ul className={topbarMenuClassName} onClick={this.props.onTopbarUserMenuClick}>
							

							
							
							
							<li role="menuitem">
								<button className="p-link ripplelink" onClick={this.cerrarSesion}>
									<i className="material-icons">cancel</i>
									<span>Cerrar Sesión</span>
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}